// src/components/Instituicoes/NewsletterForm.js

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField, Button, Box } from '@mui/material';
// Remova a importação abaixo para evitar redeclaração
// import NewsletterForm from '../../components/Instituicoes/NewsletterForm'; 

const NewsletterForm = ({ instituicaoId }) => {
  const [email, setEmail] = useState('');
  const [mensagem, setMensagem] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Implementar a lógica de inscrição na newsletter aqui
    // Por exemplo, chamar uma API para enviar email e mensagem
    console.log(`Inscrição na newsletter para a instituição ${instituicaoId}:`, { email, mensagem });
    // Resetar os campos após submissão
    setEmail('');
    setMensagem('');
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <TextField
        label="Email"
        variant="outlined"
        fullWidth
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        sx={{ mb: 2 }}
      />
      <TextField
        label="Mensagem"
        variant="outlined"
        fullWidth
        multiline
        rows={4}
        value={mensagem}
        onChange={(e) => setMensagem(e.target.value)}
        sx={{ mb: 2 }}
      />
      <Button type="submit" variant="contained" color="primary">
        Inscrever-se
      </Button>
    </Box>
  );
};

NewsletterForm.propTypes = {
  instituicaoId: PropTypes.string.isRequired,
};

export default NewsletterForm;
